import { TRANSFER_SHEET_THUMBNAILS_COUNT } from '@frameio/shared/transfers/constants';
import { reportError } from '@frameio/telemetry';
import { useGetTransferBatchEventSubscription } from '@frameio/transfers/gql/subscriptions/generated/TransferBatchEvent';
import { useJobUpdate } from '@frameio/transfers/hooks/events';
import type { PartialTransferBatch } from '@frameio/transfers/types/uploader';
import { isInTerminalState } from '@frameio/transfers/utils';

type SubscribeToUserEventsProps = {
  userId: string;
};

export const UserTransferBatchEventsSubscription = ({
  userId,
}: SubscribeToUserEventsProps) => {
  const jobUpdate = useJobUpdate();
  useGetTransferBatchEventSubscription({
    variables: {
      // By not passing in the scope, it defaults to user scope
      scope: {},
      assetPagination: { first: TRANSFER_SHEET_THUMBNAILS_COUNT },
    },
    skip: !userId,
    onData: ({
      data: {
        data: { transferBatch },
      },
    }) => {
      const transferBatchData =
        transferBatch?.transferBatch as PartialTransferBatch;
      if (!transferBatchData) return;

      const eventType = transferBatch.__typename;

      switch (eventType) {
        case 'UpdateTransferBatchPayload':
          /* We only want to use this data if the transferBatch is in a terminal state */
          if (
            transferBatchData.status !== null &&
            isInTerminalState(transferBatchData)
          ) {
            jobUpdate({ payload: { job: transferBatchData } });
          }
          break;

        default: {
          // eslint-disable-next-line no-console
          console.warn(`Unhandled user TransferBatch: ${eventType}`);
        }
      }
    },
    onError: (error) => {
      reportError(error, { message: 'GraphQL subscription error' });
    },
  });

  return null;
};
